import { IEntityFilter, IFilter } from "../../../filters";
import { FilterMap } from "../types";

const buildFilterSlugs = (filters: IFilter[]) =>
  filters.reduce((acum, filter) => ({ ...acum, [filter.slug]: filter }), {});

const buildEntityFilterSlugs = (entityFilter: IEntityFilter) => ({
  [entityFilter.entity.slug]: {
    entityFilter,
    filters: buildFilterSlugs(entityFilter.filters)
  }
});

export const createFilterMap = (entityFilters: IEntityFilter[]): FilterMap =>
  entityFilters.reduce(
    (acum, entityFilter) => ({
      ...acum,
      ...buildEntityFilterSlugs(entityFilter)
    }),
    {}
  );
